module.exports = __webpack_public_path__ + "media/images/badges/purebarre/PureBarre-4000-Classes-Active-789b4b2f3d1d4b1a08053a388c78645f.png";